<template>
  <div
    class="item">
    <div class="item-left">
      {{ info.get('content') }}
    </div>
    <div class="item-right">
      {{ infoDate(info) }}
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    info: {
      required: true,
      type: Object
    }
  },

  computed: {
    ...mapGetters('info', {
      infoDate: 'date'
    })
  }
}
</script>
